<header class="dashboard-header">
  <div class="dashboard-header__branding"></div>
  <div class="dashboard-header__controls">
    <p class="dashboard-header__title">Dashboard</p>
    <lv-site-nav></lv-site-nav>
  </div>
</header>
